export default class AbstractProvidedClass {
    constructor(provider) {
        this.provider = provider;
    }

    changesMade(silent = false) {
        this.provider.changesMade(silent);
    }

    changesSaved() {
        this.provider.changesSaved();
    }

    getTool(tool) {
        return this.provider.tools.getTool(tool);
    }

    getTab(tab) {
        return this.provider.sideBar.tabs[tab];
    }

    getInput(name) {
        let input = this.getTab('info').input;
        return Number.isInteger(name)
            ? input.multiInput.inputs[name]
            : input[name];
    }

    savePlan() {
        this.dataHandler.savePlan();
    }

    setTool(tool) {
        return this.provider.tools.setTool(tool);
    }

    calculatePixelToDisplayDistance(pixels) {
        let distance = pixels / (this.settings.metric ? 100 : 30.48);
        return Math.round(distance, 2);
    }

    emit(event, data) {
        this.provider.emit(event, data);
    }

    on(event, listener) {
        this.provider.on(event, listener);
    }

    get p() {
        return this.provider.p;
    }

    get actions() {
        return this.provider.actions;
    }

    get backgroundColor() {
        return this.provider.backgroundColor;
    }

    get cursor() {
        return this.provider.cursor;
    }

    get dataHandler() {
        return this.provider.dataHandler;
    }

    get drawMenu() {
        return this.provider.drawMenu;
    }

    get editMode() {
        return this.provider.mode == 'edit';
    }

    get elementFactory() {
        return this.provider.elementFactory;
    }

    get elements() {
        return this.provider.elements;
    }

    get enableHotKeys() {
        return this.provider.enableHotKeys;
    }

    set enableHotKeys(value) {
        this.provider.enableHotKeys = value;
    }

    get grid() {
        return this.provider.grid;
    }

    get hoverSet() {
        return this.provider.hoverSet;
    }

    get image() {
        return this.provider.image;
    }

    set image(value) {
        this.provider.image = value;
    }

    get imageMenu() {
        return this.provider.imageMenu;
    }

    set loaded(value) {
        this.provider.loaded = value;
    }

    get loaded() {
        return this.provider.loaded;
    }

    get mobile() {
        return this.provider.mobile;
    }

    get newPlant() {
        return this.provider.newPlant;
    }

    set newPlant(value) {
        this.provider.newPlant = value;
    }

    get planName() {
        return this.provider.planName;
    }

    set planName(value) {
        this.provider.planName = value;
    }

    get plants() {
        return this.provider.plants;
    }

    get selection() {
        return this.provider.selection;
    }

    get settings() {
        return this.provider.settings;
    }

    get sideBar() {
        return this.provider.sideBar;
    }

    get speciesCollection() {
        return this.provider.speciesCollection;
    }

    get speciesInfo() {
        return this.provider.speciesInfo;
    }

    get spinner() {
        return this.provider.spinner;
    }

    get storage() {
        return this.provider.storage;
    }

    set storage(value) {
        return this.provider.storage = value;
    }

    get tools() {
        return this.provider.tools;
    }

    get touch() {
        return this.provider.touch;
    }

    get view() {
        return this.provider.view;
    }

    get viewMode() {
        return this.provider.mode == 'view';
    }

    get units() {
        return this.provider.units;
    }

    get unsavedChanges() {
        return this.provider.unsavedChanges;
    }
}
